/**
 * @generated SignedSource<<1e5a7afdb9ff7bc70e993f0ad713a76f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type editConfigurationMutation$variables = {
  id: string;
  profitPercentage: number;
  provider: ProductProvider;
};
export type editConfigurationMutation$data = {
  readonly setRetailProfit: boolean;
};
export type editConfigurationMutation = {
  response: editConfigurationMutation$data;
  variables: editConfigurationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profitPercentage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "provider"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "profitPercentage",
        "variableName": "profitPercentage"
      },
      {
        "kind": "Variable",
        "name": "provider",
        "variableName": "provider"
      }
    ],
    "kind": "ScalarField",
    "name": "setRetailProfit",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "editConfigurationMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "editConfigurationMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "e83703eca75ac3905af3597f4c32bba9",
    "id": null,
    "metadata": {},
    "name": "editConfigurationMutation",
    "operationKind": "mutation",
    "text": "mutation editConfigurationMutation(\n  $id: String!\n  $provider: ProductProvider!\n  $profitPercentage: Int!\n) {\n  setRetailProfit(id: $id, provider: $provider, profitPercentage: $profitPercentage)\n}\n"
  }
};
})();

(node as any).hash = "c75788f477e2d7f15ee63c45da56c112";

export default node;
